import { render } from "./baseSlide.vue?vue&type=template&id=75bb15f8&scoped=true"
import script from "./baseSlide.vue?vue&type=script&lang=js"
export * from "./baseSlide.vue?vue&type=script&lang=js"

import "./baseSlide.vue?vue&type=style&index=0&id=75bb15f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bb15f8"]])

export default __exports__